
import React from 'react'
import people from './svgs/people.svg'
import { BaseIcon } from './_base'

export const PeopleIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon={people} {...{fontSize,size,...sx}} />
    )
}
